/* HEY MOOMI — tiny progressive enhancements (no dependencies) */
(() => {
  if (window.__hmInit) return; window.__hmInit = true;

  const io = 'IntersectionObserver' in window;

  /* Reveal on scroll */
  const reveal = (root = document) => {
    const els = root.querySelectorAll('.hm-reveal:not(.is-in)');
    if (!io) { els.forEach(e => e.classList.add('is-in')); return; }
    const ob = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); ob.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(e => ob.observe(e));
  };

  /* Play muted videos only while visible */
  const videos = (root = document) => {
    const vids = root.querySelectorAll('video[data-hm-autoplay]');
    if (!io) { vids.forEach(v => v.play && v.play().catch(() => {})); return; }
    const ob = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        const v = en.target;
        if (en.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(v => ob.observe(v));
  };

  /* Delivery estimate: business days, US Eastern time */
  const eta = (root = document) => {
    const fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
    const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
    root.querySelectorAll('[data-hm-eta]').forEach(el => {
      const now = new Date();
      const hourET = +new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: 'America/New_York' }).format(now);
      const day = now.getDay();
      const cutoff = +el.dataset.cutoff || 14;
      const ship = (day === 0 || day === 6 || hourET >= cutoff) ? addBiz(now, 1) : now;
      const a = addBiz(ship, +el.dataset.min || 5), b = addBiz(ship, +el.dataset.max || 7);
      const s = el.querySelector('[data-eta="ship"]'), r = el.querySelector('[data-eta="arrive"]');
      if (s) s.textContent = ship.toDateString() === now.toDateString() ? 'today' : 'on ' + fmt.format(ship);
      if (r) r.textContent = fmt.format(a) + ' – ' + fmt.format(b);
    });
  };

  /* Responsive video sources (desktop vs portrait mobile) */
  const srcs = (root = document) => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    root.querySelectorAll('video[data-hm-src]').forEach(v => {
      const want = (mobile && v.dataset.hmSrcMobile) || v.dataset.hmSrc;
      if (v.getAttribute('src') !== want) { v.setAttribute('src', want); v.load(); v.play().catch(() => {}); }
    });
  };

  const init = (root) => { srcs(root); reveal(root); videos(root); eta(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
